export default {
    vuex: {
        actions: {
            __notify: ({dispatch}, notification) => {

                if ( notification.text instanceof Array) {

                    switch (notification.text.length) {
                    case 0:
                        return
                    case 1:
                        notification.text = notification.text[0]
                        break
                    default:
                        // Multiple messages, don't auto hide notification
                        notification = Object.assign({ timeout: false }, notification)
                        break
                    }

                }

                // merge defaults
                notification = Object.assign({
                    type: 'info',
                    timeout: 4000,
                    id: Math.random().toString(36).substr(2,5),
                }, notification)

                dispatch('ADD_NOTIFICATION', notification)
            },
            __hideNotificationId: ({dispatch}, id) => dispatch('REMOVE_NOTIFICATION', { id: id})
        }
    },
    methods: {
        $error (text, options = {}) {
            this.__notify(Object.assign({
                text,
                type: 'error',
            }, options))
        },

        $warn (text, options = {}) {
            this.__notify(Object.assign({
                text,
                type: 'warn',
            }, options))
        },

        $success (text, options = {}) {
            this.__notify(Object.assign({
                text,
                type: 'success',
            }, options))
        },

        $info (text, options = {}) {
            this.__notify(Object.assign({
                text,
                type: 'info',
            }, options))
        },

        $hideNotification (id) {
            this.__hideNotificationId(id)
        },

        $demoSuccessNotification () {
            this.$success('De gegevens zijn aangepast. Wijzigingen gemaakt met het demo-account zullen echter niet worden verwerkt.')
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/notifications/notificationsMixin.js